module.exports = __webpack_public_path__ + "static/media/a4c.50006164.png";